import Crud from '../views/Classificacao/Crud'
import Entity from '../views/Classificacao/Add'
import View from '../views/Classificacao/View'

let routes = {
    path: '/classificacoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/classificacoes/add',
            name: 'NewClassificacoes',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Classificação de Risco',
                breadcrumb: [
                    {
                        text: 'Classificações de Risco',
                        active: false,
                        to: '/classificacoes',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/classificacoes/edit/:id?',
            name: 'EditClassificacoes',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Classificação de Risco',
                breadcrumb: [
                    {
                        text: 'Classificações de Risco',
                        active: false,
                        to: '/classificacoes',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/classificacoes/view/:id?',
            name: 'ViewClassificacoes',
            component: View,
            meta: {
                pageTitle: 'Visualizar Classificação de Risco',
                breadcrumb: [
                    {
                        text: 'Classificações de Risco',
                        active: false,
                        to: '/classificacoes',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/classificacoes',
            name: 'list-classificacoes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Classificações de Risco',
                breadcrumb: [
                    {
                        text: 'Classificações de Risco',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
